


























import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IWidget } from '@resclick/data-access';

enum Steps {
  RoomSearchStep,
  ExtraStep,
  CustomerInfoStep,
  PaymentStep,
  PreReservationStep,
  PaymentConfirmationStep,
}

@Component({
  components: {
    StepperNavigations: () => import('@/components/StepperNavigations.vue'),
    RoomSearchStep: () => import('@/views/sale/room-search.step.vue'),
    ExtraStep: () => import('@/views/sale/extras.step.vue'),
    PaymentStep: () => import('@/views/sale/payment.step.vue'),
    CustomerInfoStep: () => import('@/views/sale/customer-info.step.vue'),
    PaymentConfirmationStep: () => import('@/views/sale/payment-confirmation.step.vue'),
    PreReservationStep: () => import('@/views/sale/pre-reservation.step.vue'),
    Cart: () => import('@/components/Cart.vue'),
  },
})
export default class StepperShell extends Vue {
  @Getter('widget/additionalProducts')
  additionalProducts!: IWidget['additionalProducts'];

  step = 2;

  get lastStep() {
    return this.additionalProducts?.length ? 4 : 3;
  }

  get activeStepper() {
    return Steps[this.step];
  }

  onChangeStep(step: number) {
    this.step = step;
  }
}
